module.exports = __webpack_public_path__ + "media/kas2.fd4b0934.mp4";